/** URL `?tab=` values for work order overview (expand when adding tabs). */
export const WorkOrderOverviewTabParam = {
  OVERVIEW: "overview",
  TASKS: "tasks",
  MATERIAL_REQUESTS: "material-requests",
  ATTACHMENTS: "attachments",
} as const;

export type WorkOrderOverviewTabParamValue =
  (typeof WorkOrderOverviewTabParam)[keyof typeof WorkOrderOverviewTabParam];

const TAB_ID_TO_PARAM: Record<string, WorkOrderOverviewTabParamValue> = {
  "1": WorkOrderOverviewTabParam.OVERVIEW,
  "2": WorkOrderOverviewTabParam.TASKS,
  "3": WorkOrderOverviewTabParam.MATERIAL_REQUESTS,
  "4": WorkOrderOverviewTabParam.ATTACHMENTS,
};

const PARAM_TO_TAB_ID: Record<string, string> = {
  [WorkOrderOverviewTabParam.OVERVIEW]: "1",
  [WorkOrderOverviewTabParam.TASKS]: "2",
  [WorkOrderOverviewTabParam.MATERIAL_REQUESTS]: "3",
  [WorkOrderOverviewTabParam.ATTACHMENTS]: "4",
  // Legacy params — line items/expenses/subcontracts moved into an accordion on Overview.
  "line-items": "1",
  expenses: "1",
  subcontracts: "1",
};

export function workOrderOverviewTabIdFromSearchParam(tab: string | null): string {
  if (!tab) return "1";
  return PARAM_TO_TAB_ID[tab] ?? "1";
}

export function searchParamForWorkOrderOverviewTabId(
  tabId: string,
): WorkOrderOverviewTabParamValue | null {
  return TAB_ID_TO_PARAM[tabId] ?? null;
}

export function isValidWorkOrderOverviewTabParam(tab: string | null): boolean {
  if (!tab) return false;
  return Object.prototype.hasOwnProperty.call(PARAM_TO_TAB_ID, tab);
}
